module.exports = __webpack_public_path__ + "img/dashboard-arabic.203901f1.png";